module.exports = __webpack_public_path__ + "static/media/money-protection.6d7b5fac.svg";